import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HdmgdjHeader from "@/components/hdmgdj/HdmgdjHeader";
import HdmgdjFooter from "@/components/hdmgdj/HdmgdjFooter";
import HdmgdjReportButton from "@/components/hdmgdj/HdmgdjReportButton";
import { useHdmgdjConfig } from "@/hooks/hdmgdj/useHdmgdjConfig";
import { hdmgdjJumpTo, useHdmgdjReveal } from "@/hooks/hdmgdj/useHdmgdjScroll";
import { useHdmgdjSeo } from "@/hooks/hdmgdj/useHdmgdjSeo";
import { hdmgdjSeo } from "@/config/hdmgdjSeo";
import HdmgdjHero from "./components/HdmgdjHero";
import HdmgdjStats from "./components/HdmgdjStats";
import HdmgdjScreenshots from "./components/HdmgdjScreenshots";
import HdmgdjFeatures from "./components/HdmgdjFeatures";
import HdmgdjGenres from "./components/HdmgdjGenres";
import HdmgdjRanking from "./components/HdmgdjRanking";
import HdmgdjSteps from "./components/HdmgdjSteps";
import HdmgdjFaq from "./components/HdmgdjFaq";
import HdmgdjCta from "./components/HdmgdjCta";

export default function HdmgdjHome() {
  const { config } = useHdmgdjConfig();
  const location = useLocation();
  useHdmgdjReveal();
  useHdmgdjSeo(hdmgdjSeo.home);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const timer = window.setTimeout(() => hdmgdjJumpTo(id), 80);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <HdmgdjHeader config={config} />
      <main>
        <HdmgdjHero config={config} />
        <HdmgdjStats />
        <HdmgdjScreenshots />
        <HdmgdjFeatures />
        <HdmgdjGenres />
        <HdmgdjRanking />
        <HdmgdjSteps />
        <HdmgdjFaq />
        <HdmgdjCta config={config} />
      </main>
      <HdmgdjFooter config={config} />
      <HdmgdjReportButton />
    </div>
  );
}